import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExportComponent } from './export.component';
import { ExportRoutingModule } from './export-routing.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ExportRoutingModule,
    FormsModule,
    TranslateModule,
    TableModule,
    InputTextModule,
    ToastModule,
    ButtonModule,
    SharedModule,
    CalendarModule,
    RadioButtonModule,
    MultiSelectModule
  ],
  declarations: [ExportComponent]
})
export class ExportModule { }
